import PokerTableSeatPokers from "../../../table/module/poker_table/poker_seat_pokers_base";
import PokerTablePokerBase from "../../../table/module/poker_table/poker_table_poker_base";

const { ccclass, property, menu } = cc._decorator;

@ccclass
export default class Q2SeatCardsBase extends PokerTableSeatPokers{
    @property(cc.Boolean)
    useDynamicOffset: boolean = false

    @property(cc.Vec2)
    minOffset: cc.Vec2 = cc.Vec2.ZERO

    @property(cc.Vec2)
    maxOffset: cc.Vec2 = cc.Vec2.ZERO
    
    @property(cc.Float)
    defaultAdjustDuration: number = 0.2

    protected m_originalInterval: cc.Vec2 = null

    getOriginalInterval(): cc.Vec2{
        return this.m_originalInterval
    }

    onLoad(){
        this.m_originalInterval = cc.v2(this.intervalX, this.intervalX)
    }

    protected getIntervalX(totalColCount: number, totalRowCount: number): number{
        let intervalX = super.getIntervalX(totalColCount, totalRowCount)
        if(this.useDynamicOffset){
            if(totalColCount > 1){
                let dis = this.getOriginalInterval().x * (this.maxColCount - 1)
                intervalX = dis / (totalColCount - 1)
                intervalX = Math.max(this.minOffset.x, intervalX)
                intervalX = Math.min(this.maxOffset.x, intervalX)
            }            
        }
        return intervalX
    }

    protected getIntervalY(totalColCount: number, totalRowCount: number): number{
        let intervalY = super.getIntervalY(totalColCount, totalRowCount)
        if(this.useDynamicOffset){
            if(totalRowCount > 1){
                let dis = this.getOriginalInterval().y * (this.maxRowCount - 1)
                intervalY = dis / (totalRowCount - 1)
                intervalY = Math.max(this.minOffset.y, intervalY)
                intervalY = Math.min(this.maxOffset.y, intervalY)
            }            
        }
        return intervalY
    }

    showPokers(show: boolean, codeList?: number[], params?: any){
        let self = this
        this.unscheduleAllCallbacks()
        this.removeAllPokers()        
        if(show){
            let pokerList = this.genPokerList(codeList, false)
            let nodeList = []
            for (let index = 0; index < pokerList.length; index++) {
                let poker = pokerList[index]    
                poker.show()
                poker.showFace(poker.code != 0)
                poker.showBack(poker.code == 0)
                nodeList.push(poker.node)
                if(params){
                    if(params.hidePoker){
                        poker.hide()
                    }
                    if(params.showBack){
                        poker.showBack(true)
                        poker.showFace(false)
                    }
                }                                         
            }
            let targetCount = 0
            if(params && params){
                targetCount = params.targetLayoutCount
            }
            let centerLocalPos = this.formatPokersLayout(pokerList)

            let worldPos = this.nodePokersParent.convertToWorldSpaceAR(centerLocalPos)
            return worldPos
        }
        return cc.Vec2.ZERO
    }

    playAdjust(duration?: number, onFinish?: Function, ignoreNodeList?: cc.Node[]){
        duration = duration || this.defaultAdjustDuration
        let self = this
        let pokers = self.pokers
        self.playAdjustAnim(pokers, pokers.length, duration, 0, null, ignoreNodeList, null)
        if(onFinish){
            self.scheduleOnce(function(){
                onFinish()
            }, duration)
        }
    }

    protected formatPokersLayout(pokerList: PokerTablePokerBase[], targetCount?: number): cc.Vec2{
        if(!pokerList || pokerList.length == 0){
            return cc.Vec2.ZERO
        }
        targetCount = targetCount || pokerList.length                
        for (let i = 0; i < pokerList.length; i++) {
            let poker = pokerList[i];          
            let targetPos = this.calcPos(i, 0, targetCount, 1)
            let localPos = targetPos
            poker.node.position = localPos
            poker.original_pos = localPos
            poker.node.zIndex = i
        }
        return cc.Vec2.ZERO
    }

    protected playAdjustAnim(pokerList: PokerTablePokerBase[], targetCount: number, duration: number, delay?: number,  easingType?, ignoreNodeList?: cc.Node[], onStart?: Function){
        let self = this
        if(targetCount == 0){
            return
        }
        let isIgnoreNode = function(node: cc.Node){
            if(ignoreNodeList){
                for (let index = 0; index < ignoreNodeList.length; index++) {
                    const tmp = ignoreNodeList[index];
                    if(tmp == node){
                        return true
                    }
                }
            }
            return false
        }
        for (let index = 0; index < pokerList.length; index++) {
            const poker = pokerList[index];
            let node = poker.node
            if(isIgnoreNode(node)){
                continue
            }
            let targetPos = self.calcPos(index, 0, targetCount, 1)
            node.zIndex = index
            self.playNodeAnim(node, targetPos, 1, 0, duration, delay, easingType, null, null)
        }

    }

    protected playNodeAnim(node: cc.Node, targetPos: cc.Vec2, targetScale: number, targetAngle: number, duration: number, delay?: number, onFinish?: Function, easingType?, onStart?: Function){
        let self = this
        let do_fun = function(){
            onStart && onStart()
            let moveAnim = cc.moveTo(duration, targetPos)            
            let rotaAnim = cc.rotateTo(duration, targetAngle)
            let scaleAnim = cc.scaleTo(duration, targetScale)
            if(easingType){
                moveAnim = moveAnim.easing(easingType)
                rotaAnim = rotaAnim.easing(easingType)
                scaleAnim = scaleAnim.easing(easingType)
            }
            let tmpFun = function(){
                self.setNodeActionCallback(node, null)
                onFinish && onFinish()
            }.bind(self)
            let callFun = cc.callFunc(tmpFun)    
            self.checkAndDealCallback(node)
            node.active = true     
            self.setNodeActionCallback(node, tmpFun)
            let swap = cc.spawn([moveAnim, rotaAnim, scaleAnim])
            var seq = cc.sequence([swap, callFun])
            seq.setTag(1)
            node.stopActionByTag(1)
            node.runAction(seq)
        }
        if(delay && delay > 0){
            self.scheduleOnce(function(){
                do_fun()
            }, delay)
        }else{
            do_fun()
        }
    }

    protected playFadeAnim(node: cc.Node, from: number, to: number, duration: number, delay?: number, onFinish?: Function){
        let self = this
        let do_fun = function(){
            node.opacity = from
            let fadeAnim = cc.fadeTo(duration, to)
            let tmpFun = function(){
                self.setNodeActionCallback(node, null)
                onFinish && onFinish()
            }.bind(self)
            let callFun = cc.callFunc(tmpFun)    
            self.checkAndDealCallback(node)   
            node.active = true    
            self.setNodeActionCallback(node, tmpFun)
            var seq = cc.sequence([fadeAnim, callFun])
            seq.setTag(2)
            node.stopActionByTag(2)
            node.runAction(seq)
        }
        if(delay && delay > 0){
            self.scheduleOnce(function(){
                do_fun()
            }, delay)
        }else{
            do_fun()
        }
    }



    protected checkAndDealCallback(node: cc.Node){
        let self = this
        let lastFun = self.getNodeActionCallback(node)            
        if(lastFun){            
            lastFun()
            return self.checkAndDealCallback(node)
        }  
    }

    protected setNodeActionCallback(node: cc.Node, callback: Function){
        node['_action_callback'] = callback
    }    

    protected getNodeActionCallback(node: cc.Node){
        return node['_action_callback']
    }
}
